import React, { Component } from 'react';
import { Select } from '@cloud/atom-ui';

const { Option } = Select;

export default class extends Component {

  render() {
    const { item } = this.props;
    const { value, options, isEdit } = item;
    return (
      <>
        {
          isEdit
            ? <Select
              showSearch
              style={{ width: 200 }}
              placeholder="Select a person"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {options.map((option, index) => (
                <Option value={option.id} key={index}>{option.name}</Option>
              ))}
            </Select>
            : <div className="description">{value.name}</div>
        }

      </>
    )
  }


}


